/**
 * Background music controller
 */

let audioElement: HTMLAudioElement | null = null
let isInitialized = false
let hasStartedPlaying = false

function tryPlay(audio: HTMLAudioElement): void {
  if (hasStartedPlaying) return
  
  // Must call play() synchronously within the user gesture handler
  const playPromise = audio.play()
  
  if (playPromise !== undefined) {
    playPromise
      .then(() => {
        hasStartedPlaying = true
        console.log('Music started playing')
      })
      .catch((err) => {
        console.log('Music play failed:', err.message)
      })
  }
}

export function playMusic(volume = 0.8): void {
  const audio = document.getElementById('background-music') as HTMLAudioElement | null
  if (!audio) return
  
  audioElement = audio

  // Configure audio element
  audio.setAttribute('playsinline', 'true')
  audio.loop = true
  audio.preload = 'auto'
  audio.volume = volume
  audio.muted = false

  // Try to play immediately (will likely fail without user gesture)
  tryPlay(audio)

  // Install global unlock handlers (only once)
  if (!isInitialized) {
    isInitialized = true
    
    const unlockAudio = () => {
      if (!audioElement || hasStartedPlaying) return
      tryPlay(audioElement)
    }

    // These events qualify as "user activation" for autoplay
    // Note: scroll/wheel do NOT qualify, but touchstart/pointerdown do
    // and those fire BEFORE scroll when user drags to scroll
    document.addEventListener('click', unlockAudio, { passive: true })
    document.addEventListener('touchstart', unlockAudio, { passive: true })
    document.addEventListener('touchend', unlockAudio, { passive: true })
    document.addEventListener('pointerdown', unlockAudio, { passive: true })
    document.addEventListener('pointerup', unlockAudio, { passive: true })
    document.addEventListener('mousedown', unlockAudio, { passive: true })
    document.addEventListener('keydown', unlockAudio, { passive: true })
  }
}
